<main class="d-flex flex-column" *ngIf="(ready$ | async)">
    <!-- header -->
    <app-header></app-header>
    <!-- outlet -->
    <div class="flex-grow-1 d-flex flex-column">
        <router-outlet></router-outlet>
    </div>
    <!-- footer -->
    <app-footer></app-footer>
</main>